<template>
    <div style="margin-bottom: 6rem">
        <a-steps :current="current">
            <a-step v-for="item in steps" :key="item.title" :title="item.title" />
        </a-steps>
        <div class="steps-content">
            <div v-show="current === 0">
              <StepOne :selectedDate="selectedDate" :selectHub="selecthub"/>
            </div>
            <div v-show="current === 1">
              <StepTwo :selectedOrderList="selectedOrderList" :hubId="hubId"
                :orderDate="date" :userInfo="userInfo"/>
            </div>
            <div v-show="current === 2">
              <StepThree :selectRider="selectRider" :selectConsignment="selectConsignment" :hubId="hubId" />
            </div>
            <div v-show="current === 3">
              <StepFour :consognment="consognment"/>
            </div>
        </div>
        <div class="steps-action mb-5">
            <a-button v-if="current < steps.length - 2 && current !== 3" class="btn btn-xs" style="float: right;"
              type="primary" size="large" @click="next">
                Next
            </a-button>
            <a-button style="float: right;"
                class="btn btn-xs"
                v-if="current == steps.length - 2" size="large"
                type="primary"
                @click="next"
            >
                Done
            </a-button>

            <a-button v-if="current > 0 && current !== 3" style="margin-left: 8px" size="large" @click="prev">
                Previous
            </a-button>
        </div>
        
    </div>
</template>

<script>
import StepOne from "./StepOne.vue";
import StepTwo from "./StepTwo.vue";
import StepThree from "./StepThree.vue";
import StepFour from "./StepFour.vue";
import {alertPop} from "../../../script/helper";
import { CONSIGNMENT_CREATE } from "../../../script/api";
import { postData } from "../../../script/api-service";

export default {
  data() {
    return {
      current: 0,
      steps: [
        {
          title: 'Select Date',
          content: <StepOne></StepOne>,
        },
        {
          title: 'Order Select',
          content: 'Second-content',
        },
        {
          title: 'Rider Selection',
          content: 'Last-content',
        },
        {
          title: 'Complete',
          content: 'Last-content',
        },
      ],
      selectedOrders: [],
      date: '',
      rider_id: null,
      userInfo: null,
      consognment: null,
      hubId: null,
      consignment_id: null
    };
  },
  components: {
    StepOne,
    StepTwo,
    StepThree,
    StepFour
  },
  methods: {
    next() {
      if (this.current === 0) {
        if (!this.date) {
          alertPop("error", "First Select Date");
        } else this.current++;
      } else if (this.current === 1) {
        if (!this.selectedOrders?.length) {
          alertPop("error", "First Select Order");
        } else this.current++;
      } else if (this.current === 2 ) {
        if (!this.rider_id) alertPop("error", "First Select a rider");
        else {
          this.createconsigment()
        }
      } else return false;
    },
    prev() {
      this.current--;
    },
    selectedOrderList(data) {
      this.selectedOrders = data;
    },
    selectedDate(date) {
      this.date = date;
    },
    selectRider(riderId) {
      this.rider_id = riderId;
    },
    selectConsignment(consignmentId) {
      this.consignment_id = consignmentId;
    },
    async createconsigment() {
      let data = {
        "hub_id": this.userInfo?.hub?.id ? this.userInfo.hub.id : this.hubId ? this.hubId : '',
        "rider_id": this.rider_id,
        "order_ids": this.selectedOrders.map(e => e.id),
        "date": this.date
      }

      if (this.consignment_id) data.consignment_id = this.consignment_id;

      let res = await postData(CONSIGNMENT_CREATE, data);

      if (res) {
        alertPop("success", "Consignment Create successfully!");
        this.current++;
        this.rider_id = null;
        this.selectedOrders = []
        this.date = null;
        this.consognment = res.data.data;
        this.consignment_id = null;

        console.log("this.consognment", this.consognment);
      }
    },
    selecthub(hubId) {
      this.hubId = hubId;
    }
  },
  mounted() {
      let userInfo = localStorage.getItem('logistic-userinfo');
      this.userInfo = JSON.parse(userInfo);

      this.hubId = this.userInfo?.hub?.id ? this.userInfo.hub.id : '';
  }
};
</script>

<style scoped>
    .steps-content {
        margin-top: 30px;
        border: 1px dashed #e9e9e9;
        border-radius: 6px;
        background-color: #fff;
        min-height: 200px;
        text-align: center;
        padding-top: 50px;
    }

    .steps-action {
        margin-top: 24px;
    }
</style>